export enum LoanOriginationSystemCreateIntermediaryTypes {
  CreateIntermediary = 'loanOriginationSystemCreateIntermediary/createIntermediary',
  CreateIntermediarySuccess = 'loanOriginationSystemCreateIntermediary/createIntermediarySuccess',
  CreateIntermediaryFailure = 'loanOriginationSystemCreateIntermediary/createIntermediaryFailure',
}
